import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

// Material UI
import {Grid, Link} from '@mui/material';

import {LanguageContext} from '../../../../contexts/LanguageContext/LanguageContext';
import {greenColors} from '../../../../layouts/theme/designSystem';
import {LEGAL_PAGES_LINKS} from '../../../../lib/constants';

interface Props {
  isApplicant?: boolean;
}

export const LegalLinks = ({isApplicant}: Props) => {
  const {t} = useTranslation();
  const currentLanguage = useContext(LanguageContext);

  const getTermsOfServiceLinkBaseOnUserLanguage = () => {
    return LEGAL_PAGES_LINKS[currentLanguage]['termsOfService'];
  };

  const getTermsOfUseLinkBaseOnUserLanguage = () => {
    return LEGAL_PAGES_LINKS[currentLanguage]['termsOfUse'];
  };

  const getPrivacyPolicyLinkBaseOnUserLanguage = () => {
    return LEGAL_PAGES_LINKS[currentLanguage]['privacyPolicy'];
  };

  return (
    <>
      <Grid item mr={2}>
        {isApplicant ? (
          <Link href={getTermsOfUseLinkBaseOnUserLanguage()} target='_blank' variant='body2' color={greenColors[700]}>
            {t('registration.signUp.formLabels.termsOfUse')}
          </Link>
        ) : (
          <Link
            href={getTermsOfServiceLinkBaseOnUserLanguage()}
            target='_blank'
            variant='body2'
            color={greenColors[700]}
          >
            {t('registration.signUp.formLabels.termsOfService')}
          </Link>
        )}
      </Grid>

      <Grid item>
        <Link href={getPrivacyPolicyLinkBaseOnUserLanguage()} target='_blank' variant='body2' color={greenColors[700]}>
          {t('registration.signUp.formLabels.privacyPolicy')}
        </Link>
      </Grid>
    </>
  );
};
